export const loginRockalinguaFormContainerClassName = 'rockalingua-login-form';

/** Placeholder gray: ≥4.5:1 on white, lighter than typed text (`Colors.textBlack`) */
export const loginRockalinguaFormPlaceholderColor = '#6B6B6B';
